import google from './google';
import facebook from './facebook';
export default {
    google,
    facebook
};